import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M57.803 109.798c28.2 0 51-22.8 51-51s-22.8-51-51-51-51 22.8-51 51 22.8 51 51 51"
    />
    <path
      fill="#8F9BA8"
      d="M51.843 95.707c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5"
    />
    <path
      fill="#C7D0D9"
      d="M86.056 37.595H59.055l-8.707-8.707a5.06 5.06 0 0 0-3.606-1.495H29.943a5.1 5.1 0 0 0-5.101 5.1v46.11a4.914 4.914 0 0 0 4.907 4.904h56.592a4.823 4.823 0 0 0 4.817-4.817V42.698a5.1 5.1 0 0 0-5.101-5.101zm-56.113-5.101h16.799l5.101 5.1h-21.9z"
    />
    <path
      fill="#7B8493"
      d="M91.071 85.4a2.55 2.55 0 0 1-2.465 3.206H68.201a2.55 2.55 0 0 1-2.465-3.189 12.75 12.75 0 0 1 5.455-7.438c-3.986-3.983-3.988-10.443-.005-14.428s10.443-3.988 14.428-.005 3.988 10.443.005 14.428l-.005.005a12.75 12.75 0 0 1 5.455 7.42z"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M82.914 17.937a1.5 1.5 0 0 1 0 2.12l-10 10a1.5 1.5 0 1 1-2.121-2.121l10-10a1.5 1.5 0 0 1 2.121 0"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M70.792 17.937a1.5 1.5 0 0 1 2.121 0l10 10a1.5 1.5 0 0 1-2.121 2.122l-10-10a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M16.166 66.085c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M30.99 87.157a1.5 1.5 0 0 1 1.5 1.5v14.1a1.5 1.5 0 0 1-3 0v-14.1a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M22.39 95.757a1.5 1.5 0 0 1 1.5-1.5h14.1a1.5 1.5 0 0 1 0 3h-14.1a1.5 1.5 0 0 1-1.5-1.5M99.987 68.585c0-3.352 2.648-6 6-6s6 2.648 6 6-2.648 6-6 6-6-2.648-6-6m6-4c-2.248 0-4 1.752-4 4s1.752 4 4 4 4-1.752 4-4-1.752-4-4-4"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCustomerManagmentGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCustomerManagmentGreyscale);
export default Memo;
